module.exports = __webpack_public_path__ + "img/home-grid-info-c-xunchayuan.1df9d35a.png";